import { Directive, HostListener, Input } from '@angular/core';
import { KlevuTrackService } from '@df/module-klevu-search/klevu-track.service';
import { KlevuSearch } from './klevu-interfaces';

@Directive({
    selector: '[klevuTrackRecommendationsProductClick]',
    standalone: true
})
export class KlevuTrackRecommendationsProductClickDirective {
    @Input({
        required: true
    })
    klevuTrackRecommendationsProductClick?: KlevuSearch.IAnalyticsRecommendationTrackData<KlevuSearch.EAnalyticsRecommendationEvent.select>;

    constructor(private klevuTrackService: KlevuTrackService) {}

    @HostListener('click')
    onClick() {
        if (this.klevuTrackRecommendationsProductClick) {
            this.klevuTrackService.trackRecommendation(this.klevuTrackRecommendationsProductClick);
        }
    }
}
